import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToSection } from "./scroll";

const Footer = () => {
  const go = (e, href) => {
    e.preventDefault();
    scrollToSection(href);
  };

  return (
    <footer data-testid="site-footer" className="relative bg-ink text-bone pt-24 lg:pt-32 pb-10 overflow-hidden">
      <div
        className="pointer-events-none absolute -top-48 left-1/2 -translate-x-1/2 w-[70rem] h-[34rem] rounded-full bg-primary/10 blur-3xl"
        aria-hidden="true"
      />
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12 relative">
        <Reveal>
          <a
            href="#get-involved"
            onClick={(e) => go(e, "#get-involved")}
            data-testid="footer-cta"
            className="group block"
          >
            <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight">
              Let's build{" "}
              <em className="text-primary font-normal">home</em>
              <ArrowUpRight
                size={64}
                className="inline-block ml-4 text-primary transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2"
              />
            </h2>
          </a>
        </Reveal>

        <div className="mt-20 lg:mt-28 grid grid-cols-12 gap-10 border-t border-bone/15 pt-14">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-4" data-testid="footer-logo">
              <img
                src="/icon.png"
                alt="TNS Housing Corp house icon"
                className="h-12 w-12 rounded-xl"
              />
              <div>
                <p className="text-sm font-semibold tracking-[0.12em] text-bone leading-tight">
                  THE NEXT <span className="text-primary">STEP</span>
                </p>
                <p className="text-sm font-semibold tracking-[0.12em] text-bone/70 leading-tight">
                  HOUSING CORP
                </p>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-bone/55 max-w-sm">
              TNS Housing Corp is a 501(c)(3) nonprofit creating inclusive,
              community-rooted housing for adults with intellectual and
              developmental disabilities in Bucks County, Pennsylvania.
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-bone/40 mb-5">Explore</p>
            <ul className="space-y-3">
              {[
                ["Mission", "#mission"],
                ["Adam's Way", "#adams-way"],
                ["Impact", "#impact"],
                ["News", "#news"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    onClick={(e) => go(e, href)}
                    data-testid={`footer-link-${label.toLowerCase().replace(/['\s]/g, "-")}`}
                    className="link-line text-sm text-bone/70 hover:text-bone transition-colors duration-300"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-6 md:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-bone/40 mb-5">Visit</p>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=2003+S+Easton+Rd+Suite+304+Doylestown+PA+18901"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-map-link"
              className="link-line inline-block text-sm text-bone/70 leading-relaxed hover:text-bone transition-colors duration-300"
            >
              2003 S Easton Rd, Suite 304<br />
              Doylestown, PA 18901
            </a>
            <p className="mt-4 text-sm text-bone/70">(484) 718-5086</p>
            <a
              href="mailto:josh@tnshc.org"
              data-testid="footer-email-link"
              className="mt-2 inline-block link-line text-sm text-bone/70"
            >
              josh@tnshc.org
            </a>
            <a
              href="https://adamswaypa.org"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-adams-way-link"
              className="mt-4 flex items-center gap-1.5 link-line text-sm text-primary w-fit"
            >
              adamswaypa.org <ArrowUpRight size={14} />
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-bone/10 pt-8">
          <p className="text-xs text-bone/40" data-testid="footer-copyright">
            © 2026 TNS Housing Corp. All rights reserved.
          </p>
          <p className="text-xs text-bone/40" data-testid="footer-ein">
            TNS Housing Corp is a 501(c)(3) nonprofit organization · EIN 39-4556350
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
